import { useSyncExternalStore, useRef } from 'react';
import { useSyncPersistStore } from './persist/hooks.mjs';
import shallowEqual from './shallowEqual.mjs';

const useStore = (store, initialValue) => {
  const value = useSyncExternalStore(store.subscribe, store.get, () => initialValue || store.get());
  useSyncPersistStore(store, value);
  return [value, store.set];
};
const useGetStore = (store, initialValue) => {
  const value = useSyncExternalStore(store.subscribe, store.get, () => initialValue || store.get());
  useSyncPersistStore(store, value);
  return value;
};
const useSetStore = (store, initialValue) => {
  const value = useSyncExternalStore(store.subscribe, store.get, () => initialValue || store.get());
  useSyncPersistStore(store, value);
  return store.set;
};
function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector) {
  let isEqual = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : shallowEqual;
  const initialSelection = selector(getSnapshot());
  const stateRef = useRef(initialSelection);
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const selection = selector(snapshot);
  // 이전 상태와 현재 상태를 비교하여 필요할 때만 컴포넌트를 리렌더링
  if (!isEqual(selection, stateRef.current)) {
    stateRef.current = selection;
  }
  return stateRef.current;
}
const useStoreSelector = (store, selector, options) => {
  const {
    initialStoreValue,
    isEqual
  } = options || {};
  const value = useSyncExternalStoreWithSelector(store.subscribe, store.get, () => initialStoreValue || store.get(), selector, isEqual);
  return [value, store.set];
};

export { useGetStore, useSetStore, useStore, useStoreSelector, useSyncExternalStoreWithSelector };
